import api from '@/api';
import { API_BASE_URL } from '../../index';
import { QuestReportHourlyCostRequest } from './HourlyCost.types';

const CONTROLLER_URL = `${API_BASE_URL}/Reports`;

export async function getQuestReportHourlyCost(
  params: QuestReportHourlyCostRequest,
) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/HourlyCost`,
    params,
  )) as unknown;

  return result as BlobPart;
}
